import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import Input from '../../Form/Field/Input.jsx';
import validate from './validate.js';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Date from '../../Form/Field/Date.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import './CertificationForm.scss';

export const name = 'CertificationForm';

class CertificationForm extends Component {
  handleSubmit = (values) => {
    this.props.handleSubmit(values)
  };

  render() {
    return (
      <div id={name} className="certification-form">
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
          <div className="row align-items-end">
            <div className="col-xl-5 col-lg-4">
              <Field 
                label="Certification"
                name="label" 
                type="text"
                component={Input} />
            </div>
            <div className="col-xl-5 col-lg-5">
              <Field 
                label="Année d'obtention"
                name="date" 
                type="text"
                dateFormat="yyyy"
                component={Date} />
            </div>
            <input className="d-none" type="submit" />
          </div>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    );
  }
}

export default reduxForm({ 
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(CertificationForm);